import { youWon } from '../game/session.js';
import { useApp } from '../store.js';
import { FINISH_NOTE } from '../strings.js';
import { ShareButton } from './ShareButton.js';

export function MatchEnd() {
  const s = useApp();
  const r = s.matchResult;
  if (!r || !s.match) return null;
  const won = youWon(s);
  const [a, b] = s.match.players;
  const note = FINISH_NOTE[r.reason];
  const delta = r.ratingDelta[s.match.you];
  const coins = r.coins[s.match.you];
  return (
    <main className={`screen match-end ${won ? 'match-end--won' : 'match-end--lost'}`}>
      <div className="match-end__icon" aria-hidden="true">
        {won ? '🎉' : '😔'}
      </div>
      <h1 className="screen__title">{won ? 'Победа!' : 'Поражение'}</h1>
      <p className="match-end__score">
        {a.name} {r.score.A}:{r.score.B} {b.name}
      </p>
      {note && <p className="screen__lead">{note}</p>}
      {delta !== null && (
        <p
          className={`match-end__rating ${delta >= 0 ? 'match-end__rating--up' : 'match-end__rating--down'}`}
        >
          {delta >= 0 ? `+${delta}` : `−${Math.abs(delta)}`} рейтинга
        </p>
      )}
      {coins ? <p className="match-end__coins">+{coins} 🪙</p> : null}
      {won && (
        <ShareButton
          label="📣 Поделиться победой"
          onShare={() => s.share({ kind: 'win', matchId: r.matchId })}
        />
      )}
      <button type="button" className="play play--small" onClick={s.dismissResult}>
        {won ? 'Дальше' : 'К сетке'}
      </button>
    </main>
  );
}
